import React, { useEffect, useRef, useState } from "react";
import { getFromLocalStorage } from "../utils/Util";
import { STORAGE_KEY } from "../utils/Constant";
import "./Header.css";
import Tooltip from "../assets/Tooltip.svg";
import PowerSettings from "../assets/PowerSettings.svg";
import { setLocalLogout } from "../redux/slices/loginSlice";
import { userManager } from "../utils/AuthConfig";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
 
const Header: React.FC = () => {
  const [isProfileSecOpen, setIsProfileSecOpen] = useState(false);
 
  const profileSecRef = useRef(null);
  const profileNameRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
  const userEmail = authData?.email;
  const userName = authData?.employeeName
    ? authData?.employeeName.split(":")[0]
    : "";
 
  const getInitials = (fullName: string): string => {
    if (!fullName) return "";
    const names = fullName.trim().split(" ");
    if (names.length < 2) return names[0].charAt(0).toUpperCase();
    return (
      names[0].charAt(0) + names[names.length - 1].charAt(0)
    ).toUpperCase();
  };
 
  const handleToggleProfile = () => {
    setIsProfileSecOpen((prev) => !prev);
  };
 
  const callLogout = () => {
    dispatch(setLocalLogout({}));
    userManager
      .signoutRedirect()
      .then((response: any) => {
        // console.log("Logout initiated", response);
        toast.success("Logged Out Successfully!");
      })
      .catch((error: any) => {
        console.error("Logout error:", error);
      });
  };
 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileSecRef.current &&
        !(profileSecRef.current as HTMLDivElement).contains(event.target as Node) &&
        profileNameRef.current &&
        !profileNameRef.current.contains(event.target as Node)
      ) {
        setIsProfileSecOpen(false);
      }
    };
 
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 
 
  let username = getInitials(userName);
 
  return (
    <div className="p-4" style={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
      <div className="profile-name" onClick={handleToggleProfile} ref={profileNameRef}>
        {username}
      </div>
 
      {isProfileSecOpen && (
        <div className="profile-sec" ref={profileSecRef}>
          <img src={Tooltip} alt="Tooltip" className="profile-tooltip" />
          <div className="profile-mail">{userEmail}</div>
          <div style={{ borderBottom: "1px solid var(--tag-blue, #DDF2FF)" }}></div>
          <div className="logout-sec" onClick={callLogout}>
            <img src={PowerSettings} alt="Logout Icon" />
            <p className="profile-headings">Logout</p>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default Header;